/**
 * Router-shell de /crm — pipeline de Leads (CRM).
 *
 *   /crm              -> CrmBoard (board kanban de Leads)
 *   /crm/arquivados   -> LeadsArquivados (lista dos leads arquivados)
 *   /crm/perdidos     -> LeadsPerdidos (leads perdidos, fora do board)
 *   /crm/ganhos       -> LeadsGanhos (leads ganhos/convertidos, fora do board)
 *   /crm/leads/:leadId -> LeadCockpit (tela cheia de relacionamento)
 *
 * Cada card e um LEAD, cada coluna uma ETAPA configuravel. O detalhe do
 * orcamento gerado por um lead continua vivendo em /orcamentos/:id (shell
 * proprio) — daqui navegamos para la passando `state.from` para o cockpit.
 *
 * `<Routes location={location} key={location.pathname}>` espelha o shell de
 * /orcamentos: forca remount da arvore interna a cada mudanca de URL,
 * evitando que a tela raiz (board, com hooks pesados) nao desmonte na
 * navegacao raiz -> cockpit.
 */
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import CrmBoard from "./CrmBoard";
import LeadCockpit from "./LeadCockpit";
import LeadsArquivados from "./LeadsArquivados";
import LeadsGanhos from "./LeadsGanhos";
import LeadsPerdidos from "./LeadsPerdidos";

export default function Crm() {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route index element={<CrmBoard />} />
      <Route path="arquivados" element={<LeadsArquivados />} />
      <Route path="perdidos" element={<LeadsPerdidos />} />
      <Route path="ganhos" element={<LeadsGanhos />} />
      <Route path="leads/:leadId" element={<LeadCockpit />} />
    </Routes>
  );
}
